import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Trans } from "react-i18next";
import { Permissions } from "@whatsper/texterchat-common";
import { useStore } from "../../../../store/rootStore";
import { Operation } from "../../../EntityManager";
import { ManagerListView } from "../core";
import { ReactComponent as DashboardIcon } from "../../../../assets/icons/dashboard/Dashboard.svg";
import styles from "./DepartmentsListView.module.scss";
const DepartmentTeaser = observer(({ entity }) => {
    var _a, _b;
    const { dashboard } = useStore();
    const slaInMinutes = ((_a = entity.sla) === null || _a === void 0 ? void 0 : _a.time)
        ? dashboard.parseSlaTimeFromMillisecondsToMoment(entity.sla.time).hours() * 60 +
            dashboard.parseSlaTimeFromMillisecondsToMoment(entity.sla.time).minutes()
        : null;
    return (React.createElement("div", { className: styles.teaserContainer },
        React.createElement("div", { className: styles.departmentColor, style: { backgroundColor: entity.color } }),
        React.createElement("div", { className: styles.singleDepartmentInfo },
            React.createElement("div", { className: styles.singleDepartmentName }, entity.name),
            React.createElement("div", { className: styles.singleDepartmentAgentsNumber },
                React.createElement(Trans, { i18nKey: "numberOfAgents", count: ((_b = entity.agents) === null || _b === void 0 ? void 0 : _b.length) || 0 }),
                slaInMinutes && (React.createElement("span", { className: styles.teaserSlaTimeContainer },
                    React.createElement(DashboardIcon, null),
                    React.createElement("span", null, "SLA"),
                    React.createElement("span", null,
                        slaInMinutes,
                        " min")))))));
});
const DepartmentsListView = ({ onEntitySelect, onEntityDelete, searchQuery = "", refreshList }) => {
    const { departmentsStore, agentsStore } = useStore();
    useEffect(() => {
        refreshList === null || refreshList === void 0 ? void 0 : refreshList(departmentsStore.fetchDepartments);
    }, [refreshList]);
    const departmentsSearchQuery = searchQuery.trim().toLowerCase();
    const getOpSupported = () => {
        const { hasPermissions } = agentsStore;
        const ops = [];
        if (hasPermissions([Permissions.Permission.departments_view])) {
            ops.push(Operation.LIST);
        }
        if (hasPermissions([Permissions.Permission.departments_manage])) {
            ops.push(Operation.CREATE, Operation.EDIT, Operation.DELETE);
        }
        return ops;
    };
    const sortDepartments = (a, b) => {
        return a.name.localeCompare(b.name);
    };
    const filteredDepartments = departmentsStore.departments.slice().filter((department) => {
        var _a;
        if (!departmentsSearchQuery)
            return true;
        const name = ((_a = department.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
        return name.includes(departmentsSearchQuery);
    });
    return (React.createElement(ManagerListView, { entities: filteredDepartments, entityIdKey: "_id", teaser: DepartmentTeaser, loading: departmentsStore.loading, opSupported: getOpSupported(), onEntitySelect: onEntitySelect, onEntityDelete: onEntityDelete, createTitle: React.createElement(Trans, { i18nKey: "addDepartment" }), sorter: sortDepartments }));
};
export default observer(DepartmentsListView);
